import { gql } from '@apollo/client';
import config from 'config';

export const GET_STYLIST_BY_USERNAME = gql`
    query GetStylistByUserName($userName: String!) {
        getStylistByUserName(input: { userName: $userName }) {
            id
            phone
            firstName
            lastName
            email
            userName
            bio
            profileImageUrl
            stylistExpertise {
                id
                title
                value
            }
            gender
            level {
                title
                value
                imageUrl
            }
            availableForStylingSessions
            connectedApps {
                app
                schedulingLink
                status
            }
            approved
        }
    }
`;

export const GET_AVAILABLE_STYLIST_FOR_STYLING_SESSIONS = gql`
    query GetAvailableStylistForStylingSessions($input: GetAvailableStylistForStylingSessionInput) {
        getAvailableStylistForStylingSessions(input: $input) {
            id
            phone
            email
            lastName
            firstName
            userName
            bio
            profileImageUrl
            gender
            level {
                title
                value
                imageUrl
            }
            availableForStylingSessions
            connectedApps {
                app
                schedulingLink
                status
            }
        }
    }
`;

export const GET_USER_BY_USERNAME = gql`
    query GetUserByUserName($input: GetUserByUserNameInput!) {
        getUserByUserName(input: $input) {
            id
            phone
            firstName
            lastName
            email
            gender
            userName
            bio
            profileImageUrl
            userType
            stores {
                id
                taffiId
                name
                url
                logoImageUrl
                platform
            }
        }
    }
`;

export const GET_USER_BY_ID = gql`
    query getUserById($input: GetUserByIdInput!) {
        getUserById(input: $input) {
            id
            phone
            firstName
            lastName
            email
            userName
            bio
            profileImageUrl
            gender
            level {
                title
                value
                imageUrl
            }
            featured
            availableForStylingSessions
            connectedApps {
                app
                schedulingLink
                status
            }
        }
    }
`;
// export const GET_USERS = gql`
//     query GetUser($input: GetUserInput!) {
//         getUser(input: $input) {
//             data {
//                 id
//                 firstName
//                 lastName
//                 gender
//                 profileImageUrl
//             }
//         }
//     }
// `
const usersIndex = config.algolia.algolia_prefix + 'users';

export const GET_USERS = gql`
query AlgoliaGetUsers ($query : String!, $filters: String!, $hit : Number!, $page : Number!) {
  algoliaGetUsers @algolia(__typename: "ALGOLIA_GET_USERS", index: ${usersIndex}, filters: $filters, hitsPerPage: $hit, query: $query, page: $page) {
      hits
      nbHits
      facets
      page
      nbPages
  }
}
`;
